import { usePersonalView } from "../../lib/usePersonalView";
import { ARTICLE_DETAIL_PERIOD_OPTIONS, DEFAULT_ARTICLE_DETAIL_PERIOD, type ArticleDetailPeriodSelection } from "./period";

/** Shared actor/tenant preference; URL overrides never write on their own. */
export function useArticlePeriodPreference() {
  const view = usePersonalView("article_period");
  const mode = view.params.get("period") ?? (view.params.has("from") || view.params.has("to") ? "custom" : DEFAULT_ARTICLE_DETAIL_PERIOD.mode);
  const selection: ArticleDetailPeriodSelection = {
    mode: ARTICLE_DETAIL_PERIOD_OPTIONS.find(option => option.value === mode)?.value ?? "custom",
    customFrom: view.params.get("from") ?? "",
    customTo: view.params.get("to") ?? "",
  };
  const change = (next: ArticleDetailPeriodSelection, valid: boolean) => {
    const params = new URLSearchParams(view.params);
    for (const key of ["period", "from", "to", "view"]) params.delete(key);
    params.set("period", next.mode);
    if (next.mode === "custom") { params.set("from", next.customFrom); params.set("to", next.customTo); }
    if (valid) view.change(params);
    else view.setUrl(params); // Show incomplete/invalid drafts without replacing the last valid preference.
  };
  return { view, selection, change };
}
